/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, pxToEmWithBaseline, replacePXinStringWithEM, centerAbsolutely, imageTypes, animations, mediaQuery, convertHexToRGB } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- USER DATA COLLECTION SUCCESS PHASE STYLES --------------- ++++++++++ */
export default {
    udcsuccess: {
        '& .successmessage': {
            '& .graphic.success': {
                backgroundColor: 'transparent',
                backgroundImage: `url(${url.image.app}/icon-submit-success.svg )`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50%',
                backgroundSize: 'contain',
                width: '100%',
                height: pxToEm(66),
                margin: replacePXinStringWithEM('25px auto 16px'),
                // animation
                opacity: '0',
                animationName: 'rotateIn',
                animationDuration: '.3s',
                animationDelay: '.2s',
                animationFillMode: 'forwards'
            },
            '& .title': {
                // animation
                fontSize: pxToEmWithBaseline({ value: 24, fontSizeBaseline: 18 }),
                marginBottom: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 21 }),
                opacity: '0',
                animationName: 'fadeInUp',
                animationDuration: '.3s',
                animationDelay: '.3s',
                animationFillMode: 'forwards'
            },
            '& .bodycopy': {
                fontSize: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 14 }),
                marginBottom: pxToEmWithBaseline({ value: 24, fontSizeBaseline: 18 }),
                // animation
                opacity: '0',
                animationName: 'fadeInUp',
                animationDuration: '.4s',
                animationDelay: '.4s',
                animationFillMode: 'forwards',
                '& p': {
                    marginBottom: 0
                }
            }
        },
        '& .ctas': {
            textAlign: 'center',
            '& .button': {
                width: pxToEmWithBaseline({ value: 82, fontSizeBaseline: 14 }),
                height: pxToEmWithBaseline({ value: 32, fontSizeBaseline: 14 }),
                padding: 0,
                '&.white': {
                    color: `rgb(23, 60, 128)`
                }
            }
        }
    }
};
